import React from 'react';
import { Route } from 'react-router';
import PackerRouteView from './packerRoutesRouteView';
import PackerRoutesIndex from './packerRoutesIndex';

const PackerRoutes = ({ match }) => {
  return (
    <div className="packer m-b-6">
      <Route exact path={`${match.path}`} render={(props) => <PackerRoutesIndex {...props} />} />
      <Route exact path={`${match.path}/route/:routeId`} render={(props) => <PackerRouteView {...props} />} />
      <Route
        path={`${match.path}/route/:routeId/:customPackingType`}
        render={(props) => <PackerRouteView {...props} />}
      />
    </div>
  );
};

PackerRoutes.propTypes = {};

PackerRoutes.defaultProps = {};

export default PackerRoutes;
